import Card from "src/components/Card";
import Loader from "src/components/Loader";

interface TableProps {
	variant: "card" | "flat";
	fetching?: boolean;
	children?: any;
	headers?: any[];
	footer?: any;
}

const Table = ({
	variant,
	fetching,
	children,
	headers,
	footer,
}: TableProps) => {
	let className = "w-full leading-normal";

	if (variant === "flat") {
		return (
			<div className="lg:overflow-x-auto bg-white hide-scrollbar">
				<table {...{ className }}>
					<thead className="bg-white border-b-[1px] border-gray">
						<tr>
							{headers?.map((item, index) => (
								<th
									className="py-3 px-6 text-left font-bold relative"
									key={item}
								>
									<p className="mb-0 whitespace-nowrap">
										{item}
									</p>
									{index === 0 && fetching && (
										<div className="absolute top-0 right-0 bottom-0 flex items-center">
											<Loader />
										</div>
									)}
								</th>
							))}
						</tr>
					</thead>
					<tbody>{children}</tbody>
					<tfoot>{footer}</tfoot>
				</table>
			</div>
		);
	}

	return (
		<Card type="no-padding" className="overflow-x-auto bg-white">
			<table {...{ className }}>
				<thead className="bg-white border-b-[1px] border-gray">
					<tr>
						{headers?.map((item) => (
							<th className="p-6 text-left font-bold" key={item}>
								<p className="mb-0 whitespace-nowrap">{item}</p>
							</th>
						))}
					</tr>
				</thead>
				<tbody>{children}</tbody>
				<tfoot>{footer}</tfoot>
			</table>
		</Card>
	);
};

Table.defaultProps = {
	variant: "card",
};

interface Props {
	children?: any;
	className?: string;
}

interface TableRowProps extends Props {}

const TableRow = ({ children, className: _className }: TableRowProps) => {
	let className = `${_className}`;
	if (!className?.includes("border-")) {
		className += ` border-b-[1px] border-gray`;
	}
	return <tr {...{ className }}>{children}</tr>;
};

interface TableCellProps extends Props {
	colSpan?: number;
}

const TableCell = ({ children, className, ...rest }: TableCellProps) => {
	let _className = `px-6 py-4 text-left ${className || ""}`;
	if (!_className.includes("w-")) {
		_className += " w-max";
	}

	return (
		<td {...rest} className={_className}>
			{children}
		</td>
	);
};

Table.Row = TableRow;
Table.Cell = TableCell;

export default Table;
